// Utilidades de fecha compartidas por los componentes de Programa.
// Todas las fechas de obra se calculan en hora de Chile continental (America/Santiago).

export function hoyEnSantiago() {
  const fechaStr = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Santiago' });
  return new Date(fechaStr + 'T00:00:00-04:00');
}
